var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { useCpaProduct } from 'components/Cpa/CpaProduct/CpaProductContextProvider';
import { InputFieldsContainer } from 'components/Shared/InputFieldsContainer/InputFieldsContainer';
import { inputFieldsContainerHelper } from 'components/Shared/InputFieldsContainer/InputFieldsContainerHelper';
import { ActionType, InputFieldType } from 'models/Input/InputModels';
import { createLock, EXTRA_DATA_SALES_CATEGORY_FIELD_NAMES } from 'utils/cpa-utils';
import { getUserOrSignIn } from 'services/auth/AuthService';
import { useBanner, BannerMessageType, BannerIconType } from 'components/Shared/BannerContext/BannerContext';
export function CpaExtraDataSalesCategoryWorkOrder(_a) {
    var _b;
    var _this = this;
    var disabledEdit = _a.disabledEdit;
    var cpaProductContext = useCpaProduct();
    var _c = useBanner(), setBannerMessage = _c.setBannerMessage, setBannerType = _c.setBannerType, setBannerIcon = _c.setBannerIcon, setShowBanner = _c.setShowBanner, setIsRefreshEnabled = _c.setIsRefreshEnabled;
    /**
     * Declare state to hold field values of all columns , key as column heading
     */
    var _d = useState(buildFieldValues(undefined)), fieldValues = _d[0], setFieldValues = _d[1];
    var colDef = {
        title: { displayText: 'Sales Category:' },
        rowGap: '24px',
        showActions: false,
        preventReadOnly: true,
        disabled: disabledEdit,
        fields: (_b = {},
            _b[EXTRA_DATA_SALES_CATEGORY_FIELD_NAMES.SALES_BRAND_CODE] = {
                fieldName: 'Sales Brand Code:',
                displaySeq: 0,
                input: {
                    type: InputFieldType.STRING,
                },
                hasTextField: false,
                hasLookup: false,
            },
            _b[EXTRA_DATA_SALES_CATEGORY_FIELD_NAMES.SALES_CATEGORY_CODE] = {
                fieldName: 'Sales Category Code:',
                displaySeq: 1,
                input: {
                    type: InputFieldType.STRING,
                },
                hasTextField: false,
                hasLookup: false,
            },
            _b[EXTRA_DATA_SALES_CATEGORY_FIELD_NAMES.SALES_PRODUCT_LINE_CODE] = {
                fieldName: 'Sales Product Line Code:',
                displaySeq: 3,
                input: {
                    type: InputFieldType.STRING,
                },
                hasTextField: false,
                hasLookup: false,
            },
            _b[EXTRA_DATA_SALES_CATEGORY_FIELD_NAMES.SALES_SUB_CATEGORY_CODE] = {
                fieldName: 'Sales Sub-Category Code:',
                displaySeq: 2,
                input: {
                    type: InputFieldType.STRING,
                },
                hasTextField: false,
                hasLookup: false,
            },
            _b[EXTRA_DATA_SALES_CATEGORY_FIELD_NAMES.SALES_TYPE_CODE] = {
                fieldName: 'Sales Type Code:',
                displaySeq: 4,
                input: {
                    type: InputFieldType.STRING,
                },
                hasTextField: false,
                hasLookup: false,
            },
            _b),
    };
    useEffect(function () {
        var _a;
        if (!((_a = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data) === null || _a === void 0 ? void 0 : _a.currentProduct)) {
            return;
        }
        var initialValues = buildFieldValues(cpaProductContext.data.currentProduct);
        setFieldValues(initialValues);
    }, [cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.currentProduct]);
    var handleAction = function (actionType) { return __awaiter(_this, void 0, void 0, function () {
        var cpn, sessionId, user, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!((_a = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data) === null || _a === void 0 ? void 0 : _a.currentProduct)) {
                        return [2 /*return*/];
                    }
                    if (!(actionType === ActionType.CONFIRM)) return [3 /*break*/, 1];
                    postConfirmationUpdate();
                    return [3 /*break*/, 7];
                case 1:
                    if (!(actionType === ActionType.REVERT)) return [3 /*break*/, 2];
                    setFieldValues(buildFieldValues(cpaProductContext.data.currentProduct));
                    return [3 /*break*/, 7];
                case 2:
                    if (!(actionType === ActionType.EDIT)) return [3 /*break*/, 7];
                    cpn = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn;
                    sessionId = sessionStorage.getItem("".concat(cpn, "_identifier"));
                    if (!(cpn && sessionId)) return [3 /*break*/, 7];
                    return [4 /*yield*/, getUserOrSignIn()];
                case 3:
                    user = _b.sent();
                    _b.label = 4;
                case 4:
                    _b.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, createLock(cpn, user.name, sessionId, cpaProductContext.data.currentProduct.startDate)];
                case 5:
                    _b.sent();
                    return [3 /*break*/, 7];
                case 6:
                    err_1 = _b.sent();
                    setBannerMessage("This record is locked because it's currently being edited by somone else. Please reload by clicking here: ");
                    setBannerType(BannerMessageType.Warning);
                    setBannerIcon(BannerIconType.Error);
                    setShowBanner(true);
                    setIsRefreshEnabled(true);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var postConfirmationUpdate = function () {
        cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.dispatch({
            type: 'UPDATE_CURRENT_PRODUCT',
            payload: __assign({}, cpaProductContext.data.currentProduct),
        });
    };
    return (_jsx(InputFieldsContainer, { colDef: colDef, handleAction: handleAction, fieldValues: fieldValues, setFieldValue: function (property, value) {
            setFieldValues(inputFieldsContainerHelper.getUpdatedFieldValues(fieldValues, property, value));
        } }));
}
var buildFieldValues = function (currentProduct) {
    var _a;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    return (_a = {},
        _a[EXTRA_DATA_SALES_CATEGORY_FIELD_NAMES.SALES_BRAND_CODE] = {
            value: getCodeAndDescription((_b = currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.salesCategory) === null || _b === void 0 ? void 0 : _b.brandCode, (_c = currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.salesCategory) === null || _c === void 0 ? void 0 : _c.brandDesc),
        },
        _a[EXTRA_DATA_SALES_CATEGORY_FIELD_NAMES.SALES_PRODUCT_LINE_CODE] = {
            value: getCodeAndDescription((_d = currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.salesCategory) === null || _d === void 0 ? void 0 : _d.productLineCode, (_e = currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.salesCategory) === null || _e === void 0 ? void 0 : _e.productLineDesc),
        },
        _a[EXTRA_DATA_SALES_CATEGORY_FIELD_NAMES.SALES_CATEGORY_CODE] = {
            value: getCodeAndDescription((_f = currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.salesCategory) === null || _f === void 0 ? void 0 : _f.categoryCode, (_g = currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.salesCategory) === null || _g === void 0 ? void 0 : _g.categoryDesc),
        },
        _a[EXTRA_DATA_SALES_CATEGORY_FIELD_NAMES.SALES_SUB_CATEGORY_CODE] = {
            value: getCodeAndDescription((_h = currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.salesCategory) === null || _h === void 0 ? void 0 : _h.subCategoryCode, (_j = currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.salesCategory) === null || _j === void 0 ? void 0 : _j.subCategoryDesc),
        },
        _a[EXTRA_DATA_SALES_CATEGORY_FIELD_NAMES.SALES_TYPE_CODE] = {
            value: getCodeAndDescription((_k = currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.salesCategory) === null || _k === void 0 ? void 0 : _k.typeCode, (_l = currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.salesCategory) === null || _l === void 0 ? void 0 : _l.typeDesc),
        },
        _a);
};
var getCodeAndDescription = function (code, desc) {
    if (!code)
        return '';
    var truncatedDesc = '';
    if (desc) {
        truncatedDesc = desc.length > 20 ? "".concat(desc.substring(0, 20), "...") : desc;
    }
    return "".concat(code, "(").concat(truncatedDesc, ")");
};
